import React, { useState, useEffect } from 'react';
import { useAuthHeader } from 'react-auth-kit';
import axios from 'axios';
import { Modal, Container, Row, Col, ButtonToolbar, Button, Form, FormCheck} from 'react-bootstrap';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import * as Icon from 'react-feather';

function DefaultModal(props) {
    const authHeader = useAuthHeader();

        const apiUrl = process.env.REACT_APP_URL;
        const [contacts, setContacts] = useState([{name: '', phone_number: '', email: '' }]);
        const [deletedContacts, setDeletedContacts] = useState([]);

        // Initialize contacts with existing client data when component mounts
        useEffect(() => {
            if (props.data && props.data.contacts && props.data.contacts.length > 0) {
                setContacts(props.data.contacts);
            }
        }, [props.data]);

        const handleAddContacts = () => {
            setContacts([...contacts, {
                name: '',
                phone_number: '',
                email: ''
            }]);
          };

        const handleContactChange = (index, field, value) => {
            const newContacts = [...contacts];
            newContacts[index][field] = value;
            setContacts(newContacts);
        };

        const handleDeleteContact = (index) => {
            const contactToDelete = contacts[index];
            const newContacts = contacts.filter((_, i) => i !== index);

            // If the contact has an ID, add it to deletedContacts array
            if (contactToDelete.id) {
                setDeletedContacts([...deletedContacts, contactToDelete.id]);
            }

            setContacts(newContacts);
        };
        const handleButtonClick = (event) => {
            // alert('Botón de Guardar presionado');
            event.preventDefault();
            const data = {
                'id': props.data.id,
                'company_name': event.target.company_name.value,
                'legal_name': event.target.legal_name.value,
                'rfc': event.target.rfc.value,
                'days_to_pay': event.target.days_to_pay.value,
                'salesman_id': event.target.salesman_id.value,
                'regimen_fiscal': event.target.regimen_fiscal.value || null,
                'uso_cfdi': event.target.uso_cfdi.value || null,
                'codigo_postal': event.target.codigo_postal.value || null,
                'email': event.target.client_email.value || null,
                'contacts': contacts,
                'deleted_contacts': deletedContacts};
                console.log(data);
            axios({
                method:'PUT',
                url:apiUrl+'/finance/client',
            headers: {
                Authorization: authHeader()
            },
                data: data
            }).then(response => {
                console.log(response);
                props.onHide();
            })
            .catch(error => {
                console.log(error);
                alert(error);
            });
        }
        return (
            <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Editar Cliente
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Container>
                        <Form onSubmit={handleButtonClick}>
                            <Row className="mb-3">
                                <h4>Datos del cliente</h4>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="company_name">
                                    <Form.Label>Nombre de la Empresa</Form.Label>
                                    <Form.Control placeholder="Kinexion" defaultValue={props.data.company_name} />
                                </Form.Group>
                                <Form.Group as={Col} controlId="legal_name">
                                    <Form.Label>Razón Social</Form.Label>
                                    <Form.Control placeholder="NEXATEC" defaultValue={props.data.legal_name} />
                                </Form.Group>
                                <Form.Group as={Col} controlId="rfc">
                                    <Form.Label>RFC</Form.Label>
                                    <Form.Control placeholder="RFC123456" defaultValue={props.data.rfc} />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="salesman_id">
                                    <Form.Label>Vendedor</Form.Label>
                                    <Form.Select defaultValue={props.data.salesman_id || '0'}>
                                        <option value='0'></option>
                                        <option value='3'>Cristopher</option>
                                        <option value='4'>Xavier</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col} controlId="days_to_pay">
                                    <Form.Label>Días de crédito</Form.Label>
                                    <Form.Control
                                            type="number"
                                            min="5"
                                            max="90"
                                            step="5"
                                            defaultValue={props.data.days_to_pay || 5}
                                            />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <h6>SAT / Carta Porte</h6>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="regimen_fiscal">
                                    <Form.Label>Régimen Fiscal</Form.Label>
                                    <Form.Select defaultValue={props.data.regimen_fiscal || ""}>
                                        <option value="">Seleccionar...</option>
                                        <option value="601">601 - General de Ley PM</option>
                                        <option value="603">603 - PM Fines no Lucrativos</option>
                                        <option value="605">605 - Sueldos y Salarios</option>
                                        <option value="606">606 - Arrendamiento</option>
                                        <option value="608">608 - Demás ingresos</option>
                                        <option value="610">610 - Residentes en el Extranjero</option>
                                        <option value="612">612 - PF Act. Empresariales</option>
                                        <option value="620">620 - Soc. Cooperativas</option>
                                        <option value="621">621 - Incorporación Fiscal</option>
                                        <option value="622">622 - Act. Agrícolas/Ganaderas</option>
                                        <option value="623">623 - Grupos de Sociedades</option>
                                        <option value="624">624 - Coordinados</option>
                                        <option value="625">625 - Plataformas Tecnológicas</option>
                                        <option value="626">626 - RESICO</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col} controlId="uso_cfdi">
                                    <Form.Label>Uso CFDI</Form.Label>
                                    <Form.Select defaultValue={props.data.uso_cfdi || ""}>
                                        <option value="">Seleccionar...</option>
                                        <option value="G01">G01 - Adquisición de mercancías</option>
                                        <option value="G02">G02 - Devoluciones/descuentos</option>
                                        <option value="G03">G03 - Gastos en general</option>
                                        <option value="I01">I01 - Construcciones</option>
                                        <option value="I02">I02 - Mobiliario y equipo</option>
                                        <option value="I03">I03 - Equipo de transporte</option>
                                        <option value="I04">I04 - Equipo de cómputo</option>
                                        <option value="I08">I08 - Otra maquinaria</option>
                                        <option value="P01">P01 - Por definir</option>
                                        <option value="S01">S01 - Sin efectos fiscales</option>
                                        <option value="CP01">CP01 - Pagos</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col} controlId="codigo_postal">
                                    <Form.Label>Código Postal</Form.Label>
                                    <Form.Control placeholder="44100" defaultValue={props.data.codigo_postal || ""} />
                                </Form.Group>
                                <Form.Group as={Col} controlId="client_email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" placeholder="cliente@empresa.com" defaultValue={props.data.email || ""} />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col}>
                                <h4>Contactos</h4>
                                </Form.Group>
                            </Row>
                            {contacts.map((row, index) => (
                                <div key={index}>
                                    <Row className="mb-3">
                                    <Form.Group as={Col} controlId={`name_${index}`}>
                                        <Form.Label>Contacto</Form.Label>
                                        <Form.Control
                                        placeholder="Juan"
                                        value={row.name}
                                        onChange={(e) => handleContactChange(index, 'name', e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId={`phone_number_${index}`}>
                                        <Form.Label>Teléfono</Form.Label>
                                        <Form.Control
                                        placeholder="123-456-7890"
                                        value={row.phone_number}
                                        onChange={(e) => handleContactChange(index, 'phone_number', e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId={`email_${index}`}>
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                        placeholder="example@gmail.com"
                                        value={row.email}
                                        onChange={(e) => handleContactChange(index, 'email', e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md={1} style={{display: 'flex', alignItems: 'end'}}>
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            onClick={() => handleDeleteContact(index)}
                                            disabled={contacts.length <= 1}
                                        >
                                            <Icon.Trash2 size={16} />
                                        </Button>
                                    </Form.Group>
                                    </Row>
                                </div>
                            ))}
                            <div className="mb-3" style={{textAlign:"end"}}>
                                <Button onClick={handleAddContacts}>+</Button>
                            </div>
                            <Button type="submit" value="Submit">Guardar</Button>
                        </Form>
                    </Container>
                </Modal.Body>
            </Modal>
        );
}

class ModalWithGrid extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = { modalShow: false };
    }

    render() {
        let add_new_input = () => {this.props.setData(); this.setState({ modalShow: false });}
        return (
            <ButtonToolbar>
                <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => this.setState({ modalShow: true })}
                >
                    <Icon.Edit size={14} />
                </Button>
                <DefaultModal show={this.state.modalShow} onHide={add_new_input} data={this.props.clientInfo}/>
            </ButtonToolbar>
        );
    }
}

export default ModalWithGrid;
